module.exports = __webpack_public_path__ + "static/img/2025年历-10.20eaac9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2025年历-10.png
// module id = sn00
// module chunks = 3